import { render, staticRenderFns } from "./jzsReturnDetail.vue?vue&type=template&id=4b3f3eb3&scoped=true&"
import script from "./jzsReturnDetail.vue?vue&type=script&lang=js&"
export * from "./jzsReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./jzsReturnDetail.vue?vue&type=style&index=0&id=4b3f3eb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3f3eb3",
  null
  
)

export default component.exports